import { Table, ToggleButtonGroup } from 'react-bootstrap';
import styled from 'styled-components';

export const FilterWrapper = styled(ToggleButtonGroup)`
    .credits {
        background-color: #B0E69C;
    }

    .debits {
        background-color: #df2020;
        color: white;
    }

    .net {
        background-color: #99b3ff;
    }
`;

export const RevenueWrapper = styled(Table)`
    width: initial;
    margin-bottom: 0px;

    tbody > tr > th,
    tbody > tr > td {
        padding: 4px 8px 4px 8px;
    }

    tbody > tr > th {
        width: 300px;
    }

    tbody > tr > td {
        text-align: right;
    }
`;

export const ReportWrapper = styled.div`
    width: 100%;
    height: 63vh;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-cell::after {
        //border-right: 1px solid #ccc;
        content: " ";
        height: 16px;
        margin-top: 4px;
        position: absolute;
        text-indent: -2000px;
        top: 0;
        right: 0;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-floating-top {
        overflow: hidden !important;
    }

    .ag-row {
        z-index: 0;
    }

        .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-header-group-cell-label {
        justify-content: center;
    }

    .list-group-header {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        // border-left-width: 0px;
        // border-right-width: 1px;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
    }

    .list-header {
        //background-color: #F6CC9F;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-cell {
        //background-color: #F6CC9F;
        //color: black;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
    }

    .list-header-debits {
        // background-color: #df2020;
        // color: white;
        // display: flex;
        // justify-content: center;
        // align-items: flex-end;
        // border-color: #eee;
        // font-weight: 500;
        // padding-bottom: 5px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-cell-debits {
        // background-color: #df2020;
        // color: white;
        // border-bottom: none;
        // text-align: center;
        // line-height: 28px;
        // border-color: #eee;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
    }

    .list-header-credits {
        // background-color: #B0E69C;
        // color: black;
        // display: flex;
        // justify-content: center;
        // align-items: flex-end;
        // border-color: #eee;
        // font-weight: 500;
        // padding-bottom: 5px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-cell-credits {
        // background-color: #B0E69C;
        // color: black;
        // border-bottom: none;
        // text-align: center;
        // line-height: 28px;
        // border-color: #eee;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
    }

    .list-header-net {
        // background-color: #99b3ff;
        // color: black;
        // display: flex;
        // justify-content: center;
        // align-items: flex-end;
        // border-color: #eee;
        // font-weight: 500;
        // padding-bottom: 5px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        font-weight: 500;
        padding-bottom: 5px;
    }

    .list-cell-net {
        // background-color: #99b3ff;
        // color: black;
        // border-bottom: none;
        // text-align: center;
        // line-height: 28px;
        // border-color: #eee;
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #eee;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .ag-icon.ag-icon-expanded {
        color: white;
    }

    .ag-icon.ag-icon-contracted {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;